import { useState, useEffect, useRef } from 'react';

/**
 * Hook para detectar cuándo un elemento entra en el viewport.
 * Útil para cargar componentes pesados solo cuando el usuario hace scroll hacia ellos.
 */
export const useNearScreen = ({ distance = '200px', externalRef = null } = {}) => {
  const [isNearScreen, setIsNearScreen] = useState(false);
  const fromRef = useRef();

  useEffect(() => {
    const ref = externalRef ? externalRef.current : fromRef.current;
    if (!ref) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const { isIntersecting } = entries[0];
        if (isIntersecting) {
          setIsNearScreen(true);
          observer.disconnect(); // Solo nos interesa la primera vez
        }
      },
      { rootMargin: distance }
    );

    observer.observe(ref);

    return () => observer && observer.disconnect();
  }, [distance, externalRef]);

  return { isNearScreen, fromRef };
};
